<template>
    <div class="coupons">
        <div class="coupons-cont">
            <div class="hole"/>
            <div class="coupons-cont-box">
                <div class="coupons-cont-box-title">{{ (cInfo.info && cInfo.info.length > 0) ? analyzeCouponInfo(cInfo.info).n : $t(cInfo.title) }}</div>
                <div class="coupons-cont-box-exp" :class="{'isExpiringSoon': isExpiringSoon(cInfo.expire)}">
                    <template v-if="convertDate(cInfo.expire) != null">
                        {{ $t('coupon_text1') + ': ' + convertDate(cInfo.expire) }}
                    </template>
                </div>
                <div class="coupons-cont-box-link">
                        <n-button round size="tiny" @click="showInfo(cInfo.title, cInfo.cont, analyzeCouponInfo(cInfo.info).u)">
                        {{ $t('coupon_text2') }}
                    </n-button>
                </div>
            </div>
        </div>
            <div class="coupons-btn" :class="{'exchange': (cInfo.isExchange || cInfo.isExpired)}" @click="isExchageVoucher(cInfo)">
            <div class="coupons-btn-hole-positon">
                <div class="hole"/> 
            </div>
            <div class="icon-box">
                <n-icon :component="Ticket" size="23" />
            </div>
            {{ cInfo.isExchange ? $t('coupon_text3') : cInfo.isExpired ? $t('coupon_text4') : $t('coupon_text5') }}
        </div>
    </div>
    <n-drawer v-model:show="infoFlag" :default-height="300" placement="bottom" resizable>
        <n-drawer-content :title="infoTitle" closable>
            <span style="white-space: pre-line;" v-html="infoCont" />
        </n-drawer-content>
    </n-drawer>
</template>
<script>
import { useDialog } from 'naive-ui'
import { useI18n } from "vue-i18n"
import { computed, ref, h } from 'vue'
import { Ticket, HelpCircle } from '@vicons/ionicons5'
import { useStore } from "vuex"
import naiveFnc from "@/utils/naiveFnc";
import { useRoute, useRouter } from "vue-router";
export default {
    props: {
        cInfo: Object,
    },
    setup() {
        const { crtDialog } = naiveFnc();
        const router = useRouter();
        const route = useRoute();
        const dialog = useDialog()
        const store = useStore()
        const i18n = useI18n();
        const { t } = i18n;
        const events = computed(() => store.getters["coreApi/events"]);
        const coupons = computed(() => store.getters["coreApi/coupons"]);
        const eventCouponIds = store.state.coreApi.eventCouponIds

        // 設定頁面的語系
        let simpLang = i18n.locale.value;
        let lang = 'en-us'
        switch (simpLang) {
            case 'tw':
                lang = 'zh-tw'
            break;
            case 'cn':
                lang = 'zh-cn'
            break;
            case 'jp':
                lang = 'ja-jp'
            break;
        }

        const infoFlag= ref(false)
        const infoTitle= ref('')
        const infoCont= ref('')

        const isExpiringSoon = computed(()=>{
            return function(exp){
                let isExpiringSoon = false
                if(exp.toString().substring(0,1) !== '9'){
                    if(exp.toString().length < 13) exp = exp * 1000
                    let diffDay = 7 // X天前提示快到期
                    let today = new Date().getTime()
                    let diffDayTp = diffDay * 24 * 60 * 60 * 1000

                    if(exp > today){
                        if(Math.abs(exp - today) <= diffDayTp) {
                            isExpiringSoon = true
                        }
                    }
                }
                
                return isExpiringSoon
            }
        })
        
        const convertDate = computed(()=>{
            return function(val){
                if(val.toString().substring(0,1) !== '9'){
                    if(val.toString().length < 13) val = val * 1000
                    return val ? new Date(parseInt(val)).toLocaleDateString() : ''
                } else {
                    return null
                }
            }
        })
        
        const analyzeCouponInfo = computed(()=>{            
            return function(info){
                if(info && info.length > 0){
                    return info.filter(i => i.l === lang)[0]
                } else {
                    return ''
                }
            }
        })

        function showInfo(title, cont, url){
            if(!url){
                infoTitle.value = t(title)
                infoCont.value = t(cont)
                infoFlag.value = true
            } else {
                window.location.href = url
            }
        }
        
        function isExchageVoucher(coupon){
            if(!coupon.isExchange && !coupon.isExpired){
                let title = ''
                if(coupon.title){
                    title = t(coupon.title)
                } else {
                    title = coupon.info.filter(i => i.l === lang)[0].n
                }

                const d = dialog.info({
                    icon: ()=> h('n-icon', null, h(HelpCircle)),
                    style: {'border-radius': '10px'},
                    title: title,
                    // content: ()=> h('span',{'style': 'white-space: pre-line;'}, t('coupon_text6')),
                    content: ()=> {
                        let resAry = [h('p', t('coupon_text6'))]
                        // if(coupon.code.toLocaleLowerCase() == 'hiteach50' || coupon.code.toLocaleLowerCase() == 'hiteach333'){
                        //     resAry.push(h('p', {'style': 'color: #FFA726;'}, t('coupon_text7')))
                        // }
                        return h('div', resAry)
                    },
                    positiveText: t('ok'),
                    onPositiveClick: async() => {
                        d.loading = true 
                        // 如果是COUPON暫定為直接換到底
                        if(coupon.type == "C"){
                            let res = await getCoupon(coupon.code)
                            if(res.state > 0){
                                crtDialog(t('notice'), res.msg)
                            } else {
                                let eRes = await exchangeVoucher(res.data.voucher)
                                if(eRes.state > 0){
                                    crtDialog(t('notice'), eRes.msg)
                                } else {
                                    let result = res.data
                                    let eventName = ''
                                    let eventStep = 0
                                    if(result.eventName != null && typeof result.eventName != 'undefined') {
                                        let eventTemp = result.eventName.split('-')
                                        eventName = eventTemp[0].toLocaleLowerCase()
                                        eventStep = eventTemp[1]
                                    }

                                    // 活動券設定
                                    // eventName 存在於 eventCouponIds 代表是特殊活動券,存於setting的events
                                    if(eventName != '' && eventCouponIds.indexOf(eventName) != -1) {

                                        // 是否存在於events
                                        let temp = events.value.filter( y => y.name.toLocaleLowerCase() == eventName)
                                        
                                        if(temp.length == 0) {
                                            await store.dispatch("coreApi/setUserEvents", {name: eventName, step: 1, done: new Date().getTime()})
                                        } else {
                                            await store.dispatch("coreApi/updUserEvents", {name: eventName, step: Number(eventStep), done: new Date().getTime()})
                                        }
                                    }

                                    // 優惠券設定
                                    let temp = coupons.value.filter( y => y.code == coupon.code)

                                    if(temp.length > 0){
                                        coupon.isExchange = true
                                        coupon.endTime = new Date().getTime()

                                        store.dispatch('coreApi/updUserCoupons', coupon)
                                    } else {
                                        let ticket = {
                                            type: coupon.type,
                                            code: coupon.code,   // 兌換卷號
                                            info: [], 
                                            expire: result.expire, // 到期日
                                            isExchange: true,// 是否被兌換
                                            isExpired: false, // 是否已過期
                                            endTime: new Date().getTime(),      // 結束時間(包含兌換與過期時間，預計保留半年)
                                            eventName: eventName
                                        }

                                        if(result.info) {
                                            ticket.info = JSON.parse(result.info)
                                        }

                                        if(ticket.info.length == 0){
                                            if(coupon.title) ticket.title = coupon.title
                                            if(coupon.cont) ticket.cont = coupon.cont
                                        }

                                        store.dispatch('coreApi/setUserCoupons', ticket)
                                    }
                               
                                    await store.dispatch("coreApi/setUsersetting") // 儲存現在的usersetting

                                    if(eventCouponIds.indexOf(eventName) != -1) {
                                        if(eventStep == "1") {
                                            crtDialog(t('discovery_9'), t('event3_text1'))
                                        } else {
                                            crtDialog("", t('discovery_9'))
                                        }
                                        
                                        router.push({ name: 'event3', params: { lang: route.params.lang } });
                                    } else {
                                        crtDialog("", t('discovery_9'))
                                    }
                                }
                            }
                        } else {
                            let res = await exchangeVoucher(coupon.code)
                            if(res.state > 0){
                                crtDialog(t('notice'), res.msg)
                            } else {

                                coupon.isExchange = true
                                coupon.endTime = new Date().getTime()

                                store.dispatch('coreApi/updUserCoupons', coupon)
                                await store.dispatch("coreApi/setUsersetting") // 儲存現在的usersetting

                                crtDialog("", t('discovery_9'))
                            }
                        }
                    }
                });
            }            
        }

        async function getCoupon(code){
            let errStr = ''
            let data = {}
            await store.dispatch('coreApi/getCoupon', code).then( res => {
                if(res.error) {
                    let error = res.error.toString()
                    switch(error) {
                        case '9':
                            errStr = t('error_9')
                        break
                        case '14':
                            errStr = t('error_10')
                        break
                        case '15':
                            errStr = t('error_11')
                        break
                        case '20':
                            errStr = t('error_12')
                        break
                    }
                } else {
                    data = res
                }
            }).catch( () =>{
                errStr = t('error_3')
            })

            if(errStr != ''){
                return {state: 1, msg: errStr}
            } else {
                return {state: 0, data: data}
            }
        }

        async function exchangeVoucher(voucher){
            let errStr = ''
            await store.dispatch('coreApi/exchangeVoucher', voucher).then( res => {
                if(res.error) {
                    let error = res.error.toString()
                    switch(error) {
                        // case '8':
                        //   errStr = '票卷已過期'
                        // break
                        // case '9':
                        //   errStr = '你已使用過該票券'
                        // break
                        // case '12':
                        //     errStr = '活動尚未開始'
                        // break
                        // case '16':
                        //     errStr = '降規格(權益折損)'
                        // break
                        default:
                        errStr = t('error_10')
                    }
                }
            }).catch( () =>{
                errStr = t('error_3')
            })

            if(errStr != ''){
                return {state: 1, msg: errStr}
            } else {
                return {state: 0, msg: ''}
            }
        }

        return {
            Ticket,
            HelpCircle,
            isExpiringSoon,
            convertDate,
            analyzeCouponInfo,
            showInfo,
            isExchageVoucher,
            infoFlag,
            infoTitle,
            infoCont
        }
    }
}
</script>
<style lang="less" scoped>
.coupons{
    box-shadow: 0px 3px 2px 2px #E0E0E0;
    border-radius: 10px;
    background-color: #ffffff;
    display: flex;
    width: 100%;
    margin-bottom: 10px;
    align-items:stretch;
    font-family: "Noto Sans CJK TC", "serif";
    max-width: 330px;
    min-height: 100px;
    &-cont{
        flex: 2;
        padding: 8px 16px;
        position: relative;
        display: flex;
        align-items: center;
        .hole{
            position: absolute;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: rgb(242, 244, 246);
            left: -9px;
            box-shadow: rgb(224, 224, 224) 3px 0px 2px 0px;
        }
        &-box{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            &-title{
                font-size: 16px;
                font-weight: bold;
                white-space: pre-line;
            }
            &-link{
                font-size: 13px;
            }
            &-exp{
                display: flex;
                font-size: 12px;
                &.isExpiringSoon{
                    color: #f57c00;
                    font-weight: bold;
                }
            }
        }
    }
    &-btn{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px;
        border-left: 1px dashed #9e9e9e;
        background-color: #03a9f4;
        color: #f3f3f3;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        flex-direction: column;
        flex: 1;
        &.exchange{
            background-color: #9e9e9e;
        }
        &-hole-positon{
            position: absolute;
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .hole{
                width: 20px;
                height: 20px;
                border-radius: 50%;
                position: absolute;
                background-color: rgb(242, 244, 246);
                right: -9px;
            }
        }
        .icon-box{
            border: 1px solid #fff;
            display: flex;
            border-radius: 50%;
            padding: 4px;
        }
    }
}
</style>